import React from 'react'

import { headerImages } from '../../helpers/images'

const HeaderImage = function ({ name }) {
  return <img src={headerImages[name]} alt={`${name} icon`} />
}

export default HeaderImage
